const ABProcessTriggerLifecycleCore = require("../../../core/process/tasks/ABProcessTriggerLifecycleCore");
module.exports = class ABProcessTriggerLifecycle extends (
   ABProcessTriggerLifecycleCore
) {};
